<template>
    <div class="card-deck">
        <div cols="12" md="3" v-for="(item, index) in items" :key="index" class="refill-card card">
            <div class="card-body">
                <h4>{{item.name}}</h4>
                <b-img :src="item.img"></b-img>
                <p class="refill-card-desc" v-html="item.desc"></p>
            </div>
            <div class="card-footer">
                <div class="refill-size">
                    <p class="refill-size-title">Width</p>
                    <p class="refill-size-content" v-html="item.width"></p>
                </div>
                <div class="refill-size">
                    <p class="refill-size-title">Length</p>
                    <p class="refill-size-content" v-html="item.length"></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import items from '@/data/refill/'

export default {
    data() {
        return {
            items
        }
    }
}
</script>

<style lang="scss">
    .refill-card {
        margin-bottom: 15px !important;
        .card-body {
            padding: 12px 20px;
        }
        .card-footer {
            background-color: transparent;
            border-color: transparent;
        }   
        
        h4 {
            margin-bottom: 1rem;
            color: $color-main;
            text-align: center;
        }
        img {
            width: 100%;
            margin-bottom: 1rem;
        }
        &-inner {
            margin:0 7.5px;
            padding: 10px;
            border-radius: 5px;
            box-shadow: 0 0 2px #ccc;
        }
        &-desc {
            margin-bottom: 0;
            line-height: 1.2rem;
        }
    }
    .refill-size {
        display: flex;
        align-items: center;
        -ms-flex-align: center;
        
        &:first-child {
            margin-bottom: 12px;
        }
        &-title {
            flex: 0 0 60px;
            margin-right: 10px;
            margin-bottom: 0;
            background: $color-main;
            color: #fff;
            text-align: center;
            font-size: 0.8rem;
        }
        &-content {
            margin-bottom: 0;
            line-height: 1rem;
        }
    }

    @media (min-width: 576px){
        .refill-card {
            flex: 0 0 23% !important;
        }
        .card-deck .card {
            margin-right: 7.5px;
            margin-left: 7.5px;
        }
    }
</style>